<template>
<div id="DepriciationSetupCreate" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="purchaseorderHeader" v-if="$route.params.id > 0">Update Depreciation Schedule</span>
                <span class="page-title" id="purchaseorderHeader" v-else>Add Depreciation Schedule</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backToList">
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content dep-setup-crud">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="DepriciationSetupForm">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="asset_type">Asset Type:</label>
                                    <v-select v-model="vehicle_type_id" name="vehicle_type_id" placeholder="Select Asset Type."
                                            label="text"
                                            :options="vehicleTypeArr">
                                    </v-select>
                                    <div class="field-error">{{vehicle_type_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="method">Residual</label>
                                    <input type="text" v-model="residual" id="residual" name="residual" class="form-control" placeholder="Residual" @keypress="isAmountCheck($event)">
                                    <div class="field-error">{{residual_error_msg}}</div>
                                </div>
                                 <div class="col form-group">
                                    <label class="control-label require" for="year">Start Year</label>
                                    <input type="text" v-model="start_year" id="start_year" name="start_year" placeholder="Start Year" class="form-control">
                                    <div class="field-error">{{start_year_error_msg}}</div>
                                </div>

                                <div class="col form-group">
                                    <label class="control-label require" for="method">End Year</label>
                                    <input type="text" v-model="end_year" id="end_year" name="end_year" placeholder="End Year" class="form-control">
                                    <div class="field-error">{{end_year_error_msg}}</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" v-if="$route.params.id > 0" id="CreateDepriciationSetupBtn" class="btn btn-primary" v-on:click.prevent="CreateDepriciation">
                                    <i class="fp-reload"> </i> Update
                                </button>
                                <button type="submit" v-else id="CreateDepriciationSetupBtn" class="btn btn-primary" v-on:click.prevent="CreateDepriciation">
                                    <i class="fp-save"> </i> Save
                                </button>
                                <button type="submit" v-if="$route.params.id == undefined" id="CreateAndContinueDepriciationSetupBtn" class="btn btn-tertiary" v-on:click.prevent="CreateDepriciation(flag='Save and Continue')">
                                    <i class="fp-save-continue"> </i> Save and Continue
                                </button>
                                <button type="submit" id="CancelDepriciationSetupBtn" class="btn btn-tertiary" v-on:click.prevent="backToList">
                                    <i class="fp-close"> </i> Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>

<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import moment from 'moment';


export default {
    name: "DepriciationSetupCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Depreciation Setup | " +process.env.COPYRIGHT_NAME : "Create Depreciation Setup | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins: [commonMixins, contractMixins],
    data: () => ({
        isEdit: false,
        permissions: [],
        cantAccessPage: "",
        start_year:'',
        start_year_error_msg:'',
        end_year:'',
        end_year_error_msg:'',
        residual:'',
        loading: false,
        residual_error_msg:'',
        vehicle_type_error_msg:'',
        vehicle_type_id:'',
    }),

    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_depreciation_schedule') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        
    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     self.role = userObj.roles[0].name;

            // }
            var dateFormat = userObj["date_format"];

            if ( segments[3]){
                self.loadDepriciation();
            }
        }

        self.getPermissions();
        this.loadFieldData(['vehicleType']);
        var path = window.location.pathname;
        var segments = path.split("/");

    },
    methods: {

        CreateDepriciation(flag) {
            var self = this;
            var error = false;
            self.vehicle_type_error_msg = "";
            self.start_year_error_msg = "";
            self.end_year_error_msg = "";
            self.residual_error_msg = '';

            if (!self.start_year || self.start_year == null || self.start_year == "") {
                self.start_year_error_msg = "Start Year Required.";
                error = true;
            }
            if (!self.end_year || self.end_year == null || self.end_year == "") {
                self.end_year_error_msg = "End Year Required.";
                error = true;
            }

            if (self.vehicle_type_id == null || self.vehicle_type_id == '' || !self.vehicle_type_id.value) {
                self.vehicle_type_error_msg = "Asset Type is Required.";
                error = true;
            }

             if (self.residual == '' || !self.residual || self.residual == 0) {
                self.residual_error_msg = "Residual is Required.";
                error = true;
            }

            if (!error) {

                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3]) {
                    $("#CreateDepriciationSetupBtn").val("Updating ...");
                    $("#CreateDepriciationSetupBtn").prop("disabled", true);
                    $("#CancelDepriciationSetupBtn").prop("disabled", true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#CreateAndContinueDepriciationSetupBtn").val("Saving ...");
                        $("#CreateDepriciationSetupBtn").prop("disabled", true);
                        $("#CreateAndContinueDepriciationSetupBtn").prop("disabled", true);
                        $("#CancelDepriciationSetupBtn").prop("disabled", true);

                    } else {

                        $("#CreateDepriciationSetupBtn").val("Saving ...");
                        $("#CreateDepriciationSetupBtn").prop("disabled", true);
                        $("#CreateAndContinueDepriciationSetupBtn").prop("disabled", true);
                        $("#CancelDepriciationSetupBtn").prop("disabled", true);
                    }
                }

                var fields = $("#DepriciationSetupForm").serializeArray();
                // alert(JSON.stringify(fields));

                if (self.vehicle_type_id == null) {
                    fields.push({
                        name: "vehicle_type_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "vehicle_type_id",
                        value: self.vehicle_type_id.value
                    });
                }
                fields.push({
                    name: "id",
                    value: segments[3]
                });

                // console.log(fields);
                $.ajax({
                    url: process.env.ROOT_API + "/depriciation-setup/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;

                        if (segments[3]) {
                            $("#CreateDepriciationSetupBtn").val("Update");
                            $("#CreateDepriciationSetupBtn").prop("disabled", false);
                            $("#CancelDepriciationSetupBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#CreateAndContinueDepriciationSetupBtn").val("Save and Continue");
                                $("#CreateDepriciationSetupBtn").prop("disabled", false);
                                $("#CreateAndContinueDepriciationSetupBtn").prop("disabled", false);
                                $("#CancelDepriciationSetupBtn").prop("disabled", false);

                            } else {

                                $("#CreateDepriciationSetupBtn").val("Save");
                                $("#CreateDepriciationSetupBtn").prop("disabled", false);
                                $("#CreateAndContinueDepriciationSetupBtn").prop("disabled", false);
                                $("#CancelDepriciationSetupBtn").prop("disabled", false);

                            }
                        }
                        if (data.status == "success") {

                            if (flag == "Save and Continue") {

                                $("#DepriciationSetupForm").trigger("reset");

                                self.start_year = "";
                                self.end_year = '';
                                self.residual = "";
                                self.vehicle_type_id = null;
                                self.residual = '',
                                self.residual_error_msg = "",
                                self.start_year_error_msg = '';
                                self.end_year_error_msg = '';
                                self.vehicle_type_error_msg = '';

                            } else {
                                self.$router.push("/depreciation-setup/list");
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3]) {
                            $("#CreateDepriciationSetupBtn").val("Update");
                            $("#CreateDepriciationSetupBtn").prop("disabled", false);
                            $("#CancelDepriciationSetupBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#PurchaseOrderForm").trigger("reset");
                                $("#CreateAndContinueDepriciationSetupBtn").val("Save and Continue");
                                $("#CreateDepriciationSetupBtn").prop("disabled", false);
                                $("#CreateAndContinueDepriciationSetupBtn").prop("disabled", false);
                                $("#CancelDepriciationSetupBtn").prop("disabled", false);

                            } else {

                                $("#CreateDepriciationSetupBtn").val("Save");
                                $("#CreateDepriciationSetupBtn").prop("disabled", false);
                                $("#CreateAndContinueDepriciationSetupBtn").prop("disabled", false);
                                $("#CancelDepriciationSetupBtn").prop("disabled", false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'depreciation-setup-create')

                    }
                });
            }else{
                self.errorValidationFocus();
            }
        },

        loadDepriciation() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/depreciation-setup/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);

                        if (data.status == "success") {
                            var dataSet = data.content.result;
                            self.vehicle_type_id = {text:dataSet.vtCode+' | '+dataSet.vtName,value:dataSet.vehicle_type_id};
                            self.start_year = dataSet.start_year;
                            self.end_year = dataSet.end_year;
                            self.residual = dataSet.residual;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'depreciation-setup-load')

                    }
                });
            },

        
        isNumberCheck: function (evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        backToList: function(){
            var self = this;
            self.$router.push('/depreciation-setup/list');

        },
    }
};
</script>





// WEBPACK FOOTER //
// src/components/DepreciationSetup.vue